<template>
    <div class="text-center">
        <loading-overlay :loading="loading"></loading-overlay>
        <v-dialog
            v-model="show"
            max-width="500"
            tabindex="-1"
            role="dialog"
            aria-labelledby="PaymentRecipientModal"
            aria-hidden="true"
        >
            <v-card class="elevation-12">
                <v-toolbar
                    color="primary"
                    class="mb-6"
                    dark
                    flat
                >
                    <v-toolbar-title>Payment Modal Recipient Details</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-form>
                        <!-- Select Recipient -->
                        <div v-if="filteredRecipients.length || loading">
                            <v-select
                                label="Select Recipient"
                                v-model="recipient"
                                :items="filteredRecipients"
                                item-text="recipient_info.account_name"
                                item-value="recipient_info"
                                outlined
                            />
                        </div>

                        <!-- Payment Method -->
                        <v-select
                            label="Payment Method"
                            v-model="payment_type"
                            :items="filteredPaymentTypes"
                            item-text="name"
                            item-value="code"
                            outlined
                        />

                        <!-- Payment Type Specific Fields -->
                        <component
                            v-bind:is="payment_type"
                            @cancel="$emit('cancel')"
                            @continue="continuebtn"
                            :recipientInfo="recipient"
                            @saveRecipient="saveRecipient"
                        ></component>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
    </div>
</template>

<script>
    import paypal_payment from '../components/paypal-recipient';
    import nigerian_bank_payment from '../components/nigerian-bank-recipient';
    import interac_payment from '../components/interac-recipient';
    import zelle_payment from '../components/zelle-recipient';
    import faster_payment from '../components/faster-payment-recipient';
    import sepa_payment from "../components/sepa-recipient";
    import ghana_bank_payment from "../components/ghana-bank-payment";

    export default {
        name: "payment-recipient-modal",
        data: data,
        props: {
            value: Boolean,
            pendingMatch: {},
            currency: Object,
            paymentTypes: Array,
        },
        computed: getComputed(),
        methods: getMethods(),
        components: {
            sepa_payment: sepa_payment,
            paypal_payment: paypal_payment,
            nigerian_bank_payment: nigerian_bank_payment,
            interac_payment: interac_payment,
            zelle_payment: zelle_payment,
            faster_payment: faster_payment,
            ghana_bank_payment: ghana_bank_payment
        },
        mounted: mounted
    }

    function data() {
        return {
            loading: false,
            addNew: false,
            recipientList: [],
            payment_type: '',
            payment_type_name: '',
            recipient: {},
            recipientId: null,
            banks: [],
            pageTitle: `Recipient's Details`
        }
    }

    function mounted() {
        const vm = this;
        vm.payment_type = this.currency.payment_types[0].code;
        vm.payment_type_name = this.currency.payment_types[0].name;
        setupUiElements();
        vm.getRecipientList();

        function setupUiElements() {
            vm.$store.commit('pageHeaderClass', `request`);
            vm.$store.commit('pageHeaderTitle', vm.pageTitle);
            vm.$store.commit('mobileMenuIsVisible', false);
            vm.$store.commit('closeButtonIsVisible', true);
            vm.$store.commit('hideLogoPart', false);
            vm.positionBottomButton(13);
            vm.$store.commit('addLogoPartClass', 'add-order-payment-recipient');
            vm.recipient = {}
        }
    }

    function getMethods() {
        return {
            continuebtn: continuebtn,
            cancel: cancel,
            getRecipientList: getRecipientList,
            saveRecipient: saveRecipient
        };

        function saveRecipient(copyOfRecipient) {
            let payload = {};
            payload.recipient_info = { ...copyOfRecipient };
            payload.user_id = this.$store.state.user.id;
            payload.recipient_type = this.payment_type;
            let recipientId = copyOfRecipient.id ? copyOfRecipient.id : null;
            Vue.backendApi().user(this.$store.state.user.id)
                .recipient(recipientId).storeRecipient(payload).then(success, error);

            function success(response) {
                // TODO ideas?
                console.log('Recipient Saved');
            }

            function error(error) {
                console.log('Recipient NOT saved');
            }
        }

        function getRecipientList() {
            const vm = this;
            vm.loading = true;

            Vue.backendApi()
                .user(vm.$store.state.user.id)
                .recipient()
                .listRecipients()
                .then(success, error);

            function success(response) {
                vm.loading = false;
                vm.recipientList = response.data;
            }

            function error(error) {
                vm.loading = false;
                vm.$swal({
                    type: 'error',
                    title: 'Error creating global offer',
                    text: error
                });
            }
        }

        function continuebtn(recipient) {
            this.$emit('continue', this.payment_type, recipient, this.recipientId);
        }

        function cancel() {
            const vm = this;
            vm.$store.commit('hideLogoPart', false);
            this.$emit('cancel');
        }
    }

    function getComputed() {
        return {
            pageHeaderClass: pageHeaderClass,
            filteredPaymentTypes: filteredPaymentTypes,
            filteredRecipients: filteredRecipients,
            filteredRecipientNames: filteredRecipientNames,
            show: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        }

        function pageHeaderClass() {
            return this.$store.state.pageHeaderClass;
        }

        function filteredPaymentTypes() {
            return this.currency.payment_types;
            /*
             * @todo Figure out what this code is meant to do; David Lloyd remembers that Shane requested it remain.
             *
             * However, it causes the console to complain about unreachable code.
             */

            // return this.currency.payment_types.filter(currencyPaymentType => {
            //     if (this.paymentTypes === undefined) {
            //         return true;
            //     } else {
            //         const paymentTypeIsPermitted =
            //             this.paymentTypes.indexOf(currencyPaymentType.code) >= 0;
            //         return paymentTypeIsPermitted;
            //     }
            // });
        }

        function filteredRecipients() {
            return this.recipientList.filter((recipient) => recipient.recipient_type === this.payment_type);
        }

        function filteredRecipientNames() {
            if (
                this.recipientList.recipient_type === "ghana_bank_payment" ||
                this.recipientList.recipient_type === "nigerian_bank_payment"
            ) {
                return "recipient_info.account_name";
            } else {
                return "recipient_info.name";
            }
        }

    }

    function beforeDestroy() {
        const vm = this;
        vm.$store.commit('hideLogoPart', false);
        vm.$store.commit('removeLogoPartClass', 'add-order-payment-recipient');
    }
</script>
